import { render, staticRenderFns } from "./StatusAutomationItem.vue?vue&type=template&id=98d38582&scoped=true&"
import script from "./StatusAutomationItem.vue?vue&type=script&lang=js&"
export * from "./StatusAutomationItem.vue?vue&type=script&lang=js&"
import style0 from "./StatusAutomationItem.vue?vue&type=style&index=0&id=98d38582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d38582",
  null
  
)

export default component.exports